module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ajoIK"))).then(() => parcelRequire('1iHdE'));